export const measure = 60;
export const ratio = "octave";
export const s0 = 1;

export * from "CONST/constants";

